import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../providers/DataProvider';

const Profits = () => {
  const data = (typeof useData === 'function') ? useData() : null;
  const navigate = useNavigate();
  const profits = Array.isArray(data?.transactionProfits) ? data.transactionProfits : [];
  const transactions = Array.isArray(data?.transactions) ? data.transactions : [];

  const rows = useMemo(() => {
    return profits
      .map((p) => {
        const tx = transactions.find(t => String(t.id) === String(p.transaction_id)) || {};
        return {
          id: p.transaction_id,
          date: tx.created_at || tx.date,
          type: p.transaction_type,
          branch: tx.branch_id,
          baseAmount: Number(p.base_amount || tx.amount || 0) || 0,
          revenue: Number(p.total_revenue || 0) || 0,
          costs: Number(p.total_costs || 0) || 0,
          net: Number(p.net_profit || 0) || 0,
        };
      })
      // Show only operations with profits (net > 0) and exclude orders
      .filter((r) => r.net > 0 && String(r.type).toLowerCase() !== 'order')
      .sort((a, b) => (new Date(b.date || 0)) - (new Date(a.date || 0)));
  }, [profits, transactions]);

  const openTx = (id) => navigate(`/transactions?tx=${id}`);

  return (
    <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">Ganancias por operación</h1>
      <div className="bg-white dark:bg-gray-800 rounded-xl  border border-gray-200 dark:border-gray-700 overflow-hidden neon-border">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-700/50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Fecha</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Tipo</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Monto base</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Ingresos</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Costos</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Ganancia neta</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-gray-50 hover:dark:bg-gray-700/60">
                <td className="px-6 py-3 text-sm text-gray-900 dark:text-white">{r.date ? new Date(r.date).toLocaleString() : '—'}</td>
                <td className="px-6 py-3 text-sm text-gray-900 dark:text-white">{r.type}</td>
                <td className="px-6 py-3 text-sm text-gray-900 dark:text-white">${r.baseAmount.toLocaleString('es-ES')}</td>
                <td className="px-6 py-3 text-sm text-emerald-700 dark:text-emerald-300">${r.revenue.toLocaleString('es-ES')}</td>
                <td className="px-6 py-3 text-sm text-amber-700 dark:text-amber-300">${r.costs.toLocaleString('es-ES')}</td>
                <td className="px-6 py-3 text-sm text-blue-700 dark:text-blue-300">${r.net.toLocaleString('es-ES')}</td>
                <td className="px-6 py-3 text-sm">
                  <button onClick={() => openTx(r.id)} className="text-blue-600 dark:text-blue-400 hover:text-blue-800 hover:dark:text-blue-300">Ver operación</button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="7" className="px-6 py-6 text-center text-sm text-gray-500 dark:text-gray-400">Sin ganancias registradas</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Profits;


